import React, { useEffect } from "react"

import { useTranslation } from "react-i18next"
import CRUD from "../core/genericCRUD/CRUD"
import { parsedUser } from "../../common/GetCurrentUser"
import ImportDeportados from "./Imports/ImportDeportados"
import acusacionOptions from "../../common/acusacionOptions"

const AdminDeportadosComponent = (props: any) => {
  const [t] = useTranslation("global")
  const user = parsedUser()
  const [showImportExcel, setShowImportExcel] = React.useState(false)
  const toggleImportExcel = () => {
    setShowImportExcel(!showImportExcel)

  }
  return (<>
    {showImportExcel && <ImportDeportados toggle={toggleImportExcel} />}
    <CRUD
      isModal={false}
      additionalButtons={[
        <button key="customButton"
          className="btn btn-sm btn-secondary me-2"
          onClick={() => toggleImportExcel()}>
          {t("Importar XLSX")}
        </button>
      ]}
      id="deportados"
      cssClass="modalRight"
      showModal={props.show}
      toggleCRUD={props.toggle}
      filterOpen={true}
      title={t("Deportados") ?? ""}
      icon={"fas fa-users"}
      recordButtonsPosition="start"
      getRecordsPath={`deportados/busqueda/`}
      addEditRecordPath={`deportados/AddEdit?currentUserId=${user.ID}`}
      deleteRecordPath="deportados/delete"
      filterFields={[
        {
          name: "nombre",
          htmlType: "text",
          dbType: "string",
          title: t("Nombre") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },
        {
          name: "apellido1",
          htmlType: "text",
          dbType: "string",
          title: t("Apellido 1") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },

        {
          name: "apellido2",
          htmlType: "text",
          dbType: "string",
          title: t("Apellido 2") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },

        {
          name: "alias",
          htmlType: "text",
          dbType: "string",
          title: "Alias",
          containerClass: "col-12 col-md-4",
          required: false,
        },

        {
          name: "cedula",
          htmlType: "text",
          dbType: "string",
          title: "cedula",
          containerClass: "col-12 col-md-4",
          required: false,
        },
        {
          name: "passport",
          htmlType: "text",
          dbType: "string",
          title: "Passport",
          containerClass: "col-12 col-md-4",
          required: false,
        },

      ]}
      fieldsList={[
        {
          name: "cedula",
          title: t("Informe "),
          htmlType: "informe"
        },
        {
          name: "nombres",
          title: t("Nombres"),
        },
        {
          name: "primerApellido",
          title: t("Primer Apellido"),
        },
        {
          name: "segundoApellido",
          title: t("Segundo Apellido"),
        },
        {
          name: "cedula",
          title: t("Cédula"),
        },
        {
          name: "pasaporte",
          title: t("Pasaporte"),
        },
        {
          name: "fechaNacimiento",
          title: t("Fecha de Nacimiento"),
        },
        {
          name: "alias1",
          title: t("Alias 1"),
        },
        {
          name: "alias2",
          title: t("Alias 2"),
        },
        {
          name: "alias3",
          title: t("Alias 3"),
        },
        {
          name: "nacionalidad",
          title: t("Nacionalidad"),
        },
        {
          name: "violacion",
          title: t("Violación"),
        },
        {
          name: "enlace",
          title: t("Enlace 1"),
          htmlType: "link"
        },
        {
          name: "enlace2",
          title: t("Enlace 2"),
          htmlType: "link"
        },
        {
          name: "enlace3",
          title: t("Enlace 3"),
          htmlType: "link"
        },
        {
          name: "enlace4",
          title: t("Enlace 4"),
          htmlType: "link"
        },
        {
          name: "enlace5",
          title: t("Enlace 5"),
          htmlType: "link"
        }
      ]}
      fields={[

        { name: "separator", dbType: "string", title: t("Datos Personales") ?? "", htmlType: "separator", containerClass: "col-12" },

        { name: "cedula", htmlType: "cedula", dbType: "string", title: t("Cédula") ?? "", containerClass: "col-12 col-md-6" },

        { name: "fotoCedula", htmlType: "picture", dbType: "string", title: t("Foto Cédula") ?? "", containerClass: "col-12 col-md-6" },
        { name: "id", htmlType: "hidden", dbType: "string" },
        { name: "nombres", htmlType: "text", dbType: "string", title: t("Nombres") ?? "", containerClass: "col-12 col-md-6", required: true },
        { name: "primerApellido", htmlType: "text", dbType: "string", title: t("Primer Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "segundoApellido", htmlType: "text", dbType: "string", title: t("Segundo Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "alias1", htmlType: "text", dbType: "string", title: t("Alias 1") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "alias2", htmlType: "text", dbType: "string", title: t("Alias 2") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "alias3", htmlType: "text", dbType: "string", title: t("Alias 3") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "alias4", htmlType: "text", dbType: "string", title: t("Alias 4") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "alias5", htmlType: "text", dbType: "string", title: t("Alias 5") ?? "", containerClass: "col-12 col-md-6" },
        { name: "pasaporte", htmlType: "text", dbType: "string", title: t("Pasaporte") ?? "", containerClass: "col-12 col-md-6" },
        { name: "nii", htmlType: "text", dbType: "string", title: t("NII") ?? "", containerClass: "col-12 col-md-6" },
        { name: "codigo", htmlType: "hidden", dbType: "string", title: t("Código") ?? "", containerClass: "col-12 col-md-6" },
        { name: "fechaNacimiento", htmlType: "date", dbType: "DateTimeOffset", title: t("Fecha de Nacimiento") ?? "", containerClass: "col-12 col-md-6" },
        { name: "edad", htmlType: "text", dbType: "string", title: t("Edad") ?? "", containerClass: "col-12 col-md-6" },
        { name: "lugarDeNacimiento", htmlType: "text", dbType: "string", title: t("Lugar de Nacimiento") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "nacionalidad", htmlType: "text", dbType: "string", title: t("Nacionalidad") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "nombrePadre", htmlType: "text", dbType: "string", title: t("Nombre del Padre") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "cedulaPadre", htmlType: "text", dbType: "string", title: t("Cédula del Padre") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "nombreMadre", htmlType: "text", dbType: "string", title: t("Nombre de la Madre") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "cedulaMadre", htmlType: "text", dbType: "string", title: t("Cédula de la Madre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "telefono", htmlType: "text", dbType: "string", title: t("Teléfono") ?? "", containerClass: "col-12 col-md-6" },
        { name: "direccion", htmlType: "text", dbType: "string", title: t("Dirección") ?? "", containerClass: "col-12 col-md-6" },


        { name: "separator", dbType: "string", title: t("Datos del Caso") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "no", required: false, htmlType: "hidden", dbType: "string", title: t("No") ?? "", containerClass: "col-12 col-md-6" },
        { name: "fechaDeDetencion", htmlType: "date", dbType: "DateTimeOffset", title: t("Fecha de Detención") ?? "", containerClass: "col-12 col-md-6" },
        { name: "fichado", htmlType: "hidden", dbType: "string", title: t("Fichado") ?? "", containerClass: "col-12 col-md-6" },
        { name: "noFicha", htmlType: "hidden", dbType: "string", title: t("No. Orden Judicial") ?? "", containerClass: "col-12 col-md-6" },
        { name: "noOrdenArresto", htmlType: "text", dbType: "string", title: t("No. Orden de Arresto") ?? "", containerClass: "col-12 col-md-6" },
        { name: "noExpediente", htmlType: "hidden", dbType: "string", title: t("No. Expediente") ?? "", containerClass: "col-12 col-md-6" },
        {
          name: "violacion", htmlType: "selectMultiple", dbType: "array", title: t("Acusación") ?? "", containerClass: "col-12 col-md-6", required: true,
          dataSourceLocal: acusacionOptions,
          dataSourceTextField: "name",
          dataSourceValueField: "id",
        },
        { name: "tribunal", htmlType: "text", dbType: "string", title: t("Tribunal") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "fotos", htmlType: "text", dbType: "string", title: t("Fotos") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "estatusMigratorio", htmlType: "text", dbType: "string", title: t("Estatus Migratorio") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "rutaFotos", htmlType: "text", dbType: "string", title: t("Ruta Fotos") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "idFotos", htmlType: "text", dbType: "string", title: t("ID Fotos") ?? "", containerClass: "col-12 col-md-6" },
        // { name: "carpetaFotos", htmlType: "text", dbType: "string", title: t("Carpeta Fotos") ?? "", containerClass: "col-12 col-md-6" },
        { name: "idFotoFrente", htmlType: "picture", dbType: "string", title: t("Foto") ?? "", containerClass: "col-12 col-md-6" },
        { name: "noCasoUsa", htmlType: "hidden", dbType: "string", title: t("No. Caso USA") ?? "", containerClass: "col-12 col-md-6" },
        { name: "casoEnRd", htmlType: "hidden", dbType: "string", title: t("Caso en RD") ?? "", containerClass: "col-12 col-md-6" },
        { name: "fichaEnRd", htmlType: "hidden", dbType: "string", title: t("Ficha en RD") ?? "", containerClass: "col-12 col-md-6" },
        { name: "noFichaEnRd", htmlType: "hidden", dbType: "string", title: t("No. Orden Judicial en RD") ?? "", containerClass: "col-12 col-md-6" },
        { name: "notas", htmlType: "textarea", dbType: "string", title: t("Notas") ?? "", containerClass: "col-12 " },
        { name: "separator", dbType: "string", title: t("Fuentes") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "enlace", htmlType: "text", dbType: "string", title: t("Enlace 1") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace2", htmlType: "text", dbType: "string", title: t("Enlace 2") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace3", htmlType: "text", dbType: "string", title: t("Enlace 3") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace4", htmlType: "text", dbType: "string", title: t("Enlace 4") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace5", htmlType: "text", dbType: "string", title: t("Enlace 5") ?? "", containerClass: "col-12 col-md-6" },

      ]}
    />
  </>
  )
}

export default AdminDeportadosComponent
